import { MIN_ALLOWED_AGE } from "consts/general";
import type { Moment } from "moment";
import moment from "moment";

export const adult = (isRequired = true) => (value?: string | null | Moment) => {
    if (!value) {
        return !isRequired;
    }

    if (!moment(value).isValid()) {
        return false;
    }

    if (moment().diff(moment(value), 'years') < MIN_ALLOWED_AGE) {
        return false;
    }

    return true;
};

export const json = <T extends unknown>(value: T) => {
    if (!value) {
        return true;
    }

    try {
        JSON.parse(`${value}`);
        return true;
    } catch {
        return false;
    }
};

export const fileSize = (maxSize: number) =>
    (value: File | null) => {
        if (!value || !value.size) {
            return true;
        }

        return value.size <= maxSize;
    };

export const fileType = (supportedFormats: string[]) =>
    (value: File | null) => {
        if (!value || !value.type) {
            return true;
        }

        return supportedFormats.includes(value.type);
    };

